import { render, staticRenderFns } from "./MaterialDashboardOneQueue.vue?vue&type=template&id=5a0e3546&scoped=true&"
import script from "./MaterialDashboardOneQueue.vue?vue&type=script&lang=js&"
export * from "./MaterialDashboardOneQueue.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDashboardOneQueue.vue?vue&type=style&index=0&id=5a0e3546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0e3546",
  null
  
)

export default component.exports